var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.37499C8.34518 7.37499 8.625 7.65481 8.625 7.99999V10.7778C8.625 11.1229 8.34518 11.4028 8 11.4028C7.65482 11.4028 7.375 11.1229 7.375 10.7778V7.99999C7.375 7.65481 7.65482 7.37499 8 7.37499Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.59748C7.65482 4.59748 7.375 4.87731 7.375 5.22248C7.375 5.56766 7.65482 5.84748 8 5.84748H8.00694C8.35212 5.84748 8.63194 5.56766 8.63194 5.22248C8.63194 4.87731 8.35212 4.59748 8.00694 4.59748H8Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.430542 8.00026C0.430542 3.81977 3.8195 0.430817 7.99999 0.430817C12.1805 0.430817 15.5694 3.81977 15.5694 8.00026C15.5694 12.1807 12.1805 15.5697 7.99999 15.5697C3.8195 15.5697 0.430542 12.1807 0.430542 8.00026ZM7.99999 1.68082C4.50985 1.68082 1.68054 4.51013 1.68054 8.00026C1.68054 11.4904 4.50985 14.3197 7.99999 14.3197C11.4901 14.3197 14.3194 11.4904 14.3194 8.00026C14.3194 4.51013 11.4901 1.68082 7.99999 1.68082Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.69881a86b7933398e979017b17e4a16b.svg";
export { ForwardRef as ReactComponent };